import React from "react";
import PropTypes from "prop-types";
import { Modal, Typography, Space, Divider, Button, Card } from "antd";
import { CarOutlined, CarFilled, DeleteOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

// Componente DesasignarMovilDialog para confirmar la desasignación de un vehículo
function DesasignarMovilDialog({
  open,
  onClose,
  onConfirm,
  trasladoId,
  nombreVehiculo,
  placa,
}) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={
        <Space align="center">
          <CarOutlined style={{ fontSize: "24px", color: "#faad14" }} />
          <Title level={5} style={{ margin: 0 }}>
            Confirmar Desasignación de Móvil
          </Title>
        </Space>
      }
      width={600}
      centered
      destroyOnHidden
    >
      <Card
        variant="borderless"
        style={{
          backgroundColor: "#fafafa",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          padding: "24px",
        }}
      >
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          {/* Información del Traslado */}
          <div>
            <Text type="secondary">
              Vas a desasignar el móvil del traslado con el siguiente{" "}
              <strong>CS-ID:</strong>
            </Text>
            <Title
              level={3}
              style={{
                backgroundColor: "#fff1b8",
                padding: "12px",
                borderRadius: "8px",
                textAlign: "center",
                color: "#d48806",
                marginTop: "8px",
              }}
            >
              {trasladoId || "CS-ID no disponible"}
            </Title>
          </div>
          <Divider />

          {/* Información del Vehículo */}
          <Space direction="vertical" align="center" style={{ width: "100%" }}>
            <CarFilled style={{ fontSize: "40px", color: "#1890ff" }} />
            <Text strong>Vehículo: {nombreVehiculo || "No asignado"}</Text>
            <Text strong>Placa: {placa || "No disponible"}</Text>
          </Space>
          <Divider />

          {/* Confirmación de Desasignación */}
          <Space align="center">
            <DeleteOutlined style={{ fontSize: "20px", color: "#ff4d4f" }} />
            <Text>
              ¿Estás seguro de que deseas desasignar este móvil del traslado?
              Esta acción eliminará la asignación del vehículo y conductor.
            </Text>
          </Space>
        </Space>
        <Divider />
        {/* Acciones */}
        <Space
          style={{ display: "flex", justifyContent: "flex-end" }}
          size="middle"
        >
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            type="primary"
            danger
            onClick={onConfirm}
            icon={<DeleteOutlined />}
          >
            Desasignar
          </Button>
        </Space>
      </Card>
    </Modal>
  );
}

// **Validación de las props con PropTypes**
DesasignarMovilDialog.propTypes = {
  open: PropTypes.bool.isRequired, // Booleano que indica si el diálogo está abierto
  onClose: PropTypes.func.isRequired, // Función para cerrar el diálogo
  onConfirm: PropTypes.func.isRequired, // Función para confirmar la desasignación
  trasladoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // CS-ID del traslado, puede ser string o número
  nombreVehiculo: PropTypes.string, // Nombre del vehículo
  placa: PropTypes.string, // Placa del vehículo
};

export default DesasignarMovilDialog;
